import axios from 'axios';
import {delCookie, getCookie} from "../util/cookie";
import {MessageBox} from "element-ui";
import store from "../store/store";

const noInterruptUri = ['login', 'logout', 'register', 'checkSession'];
export const request = (method, url, args = {}, header) => {
    return axios({
        method: method,
        url: process.env.BASE_API + url,
        headers: Object.assign({
            'Content-Type': 'application/json;charset=UTF-8'
        }, header || {}),
        data: args.data,
        params: args.params
    }).then(res => {
        if (!res.data.retCode){
            return res;
        }
        if (!noInterruptUri.includes(url) && res.data.retCode === 'no_login') {
            if (getCookie('g_session')) {
                MessageBox.confirm('登陆状态已过期', '温馨提示', {
                    type: 'warning',
                })
            }
            store.dispatch('login/showLoginDialog');
            store.dispatch('login/clearUserInfo');
            delCookie('g_session');
            localStorage.setItem('userinfo', null);

            return window.Promise.reject("会话过期")
        }
        return res.data;
    })
};



// WEBPACK FOOTER //
// ./src/config/axios.js